module.exports = __webpack_public_path__ + "img/aygaz-step-into-the-future-10.cbb5509b.jpg";